import AllOfComponent from './allOf'
import AnyOfComponent from './anyOf'
import ArrayComponent from './array'
import BooleanComponent from './boolean'
import DefinitionsComponent from './definitions'
import DependenciesComponent from './dependencies'
import DependencyItemComponent from './dependencyItem'
import EnumComponent from './enum'
import IntegerComponent from './integer'
import ItemsComponent from './items'
import JsonSchemaComponent from './jsonSchema'
import NotComponent from './not'
import NullComponent from './null'
import NumberComponent from './number'
import ObjectComponent from './object'
import OneOfComponent from './oneOf'
import PropertiesComponent from './properties'
import RefComponent from './ref'
import RequiredComponent from './required'
import StringComponent from './string'

export default {
  AllOfComponent,
  AnyOfComponent,
  ArrayComponent,
  BooleanComponent,
  DefinitionsComponent,
  DependenciesComponent,
  DependencyItemComponent,
  EnumComponent,
  IntegerComponent,
  ItemsComponent,
  JsonSchemaComponent,
  NotComponent,
  NullComponent,
  NumberComponent,
  ObjectComponent,
  OneOfComponent,
  PropertiesComponent,
  RefComponent,
  RequiredComponent,
  StringComponent
}



// WEBPACK FOOTER //
// ./src/components/json-schema-editor/components/index.js